module.exports = __webpack_public_path__ + "img/0859-cross-circle-blue.9736d08a.svg";